import { styled, Typography } from '@mui/material'
import { fontSize } from '@mui/system'

export const ErrorLabel = styled(Typography)(({ theme }) => ({
  marginTop: 8,
  color: theme.palette.error.main,
  fontSize: 12,
  textAlign: 'center'
}))
